import * as core from '../../../../../../../core'
import * as pullRequestReviewState from '../pull-request-review-state'

export const RESOURCE = {
  payload: {
    description: 'The latest review approves the pull request',
    enumId: core.dms.models.Enum.Id.from({
      partialId: pullRequestReviewState.RESOURCE.payload.partialId,
    }),
    id: 'APPROVED',
    name: 'Approved',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
